import { useTranslations } from 'next-intl';

export const ScrollToTop = () => {
  const tGlobal = useTranslations('Global');

  return (
    <>
      <p
        className="tw-lf-link-md tw-text-center"
        onClick={() => window.scrollTo({ top: 0, behavior: `smooth` })}
      >
        {tGlobal('scrollToTop')}
      </p>
    </>
  );
};

export default ScrollToTop;
